module.exports = __webpack_public_path__ + "static/media/kw.81db6bc7.svg";